export const SAMPLIFY = "Samplify";
export const CMIX = "Cmix";
